const formInterface = {
  getFieldDecorator: () => child => child,
  getFieldValue: () => '',
  setFieldsValue: fields => fields,
  isFieldTouched: () => false,
};

export default formInterface;
